import SessionStorageManager from 'services/SessionStorageManager'

export const STORAGE_KEY = 'tile-warnings-cache'

export const clearTileWarningsCache = () => {
  SessionStorageManager.remove(STORAGE_KEY)
}
